import { decodeHtmlEntities } from "./decode-html-entities";

const HIDDEN_HTML = /<!--[\s\S]*?-->|<(script|style)\b[\s\S]*?<\/\1\s*>/gi;
const TAG = /<\/?[a-z][^>]*>/gi;

/**
 * The visible text of a run of HTML: comments, `<script>` and `<style>` go
 * with their content, other tags become spaces (so `a</p><p>b` doesn't glue
 * into `ab`), entities decode and whitespace collapses. Decoding comes last,
 * so an escaped `&lt;b&gt;` stays visible text instead of being stripped.
 *
 * The one HTML cleaner for previews and meta text, so they can't drift. Its
 * output is plain text that may contain `<`: escape it for whatever it goes
 * into (React and Next metadata do; JSON-LD goes through `serializeJsonLd`).
 */
export function htmlToPlainText(html: string | undefined | null): string {
  if (!html) return "";
  const withoutTags = html.replace(HIDDEN_HTML, " ").replace(TAG, " ");
  return decodeHtmlEntities(withoutTags).replace(/\s+/g, " ").trim();
}
